/**
 * Einbettung per iframe (siehe public/embed.js): `?embed=1&fid=<id>`.
 * Meldet Höhe, Abschluss und Weiterleitungen an die einbettende Seite.
 */
const params = new URLSearchParams(location.search);
export const embedded = params.get("embed") === "1" && window.parent !== window;
const frameId = (params.get("fid") ?? "").slice(0, 40);

export function postToHost(msg: Record<string, unknown>) {
  if (embedded) window.parent.postMessage({ source: "fobu", fid: frameId, ...msg }, "*");
}

export function setupEmbed() {
  if (!embedded) return;
  document.documentElement.classList.add("fb-embed");
  let last = 0;
  const report = () => {
    const h = Math.ceil(document.documentElement.scrollHeight);
    if (Math.abs(h - last) > 1) {
      last = h;
      postToHost({ type: "height", height: h });
    }
  };
  new ResizeObserver(report).observe(document.documentElement);
  // Esc im Formular schließt Popup/Seitenleiste – Tasten im iframe erreichen die Host-Seite sonst nicht.
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !e.defaultPrevented) postToHost({ type: "escape" });
  });
  window.addEventListener("load", report);
}
